export class UploadDocumentReqVm {
    UserID: string;
    FolderID: number;
    TemplateID: number;
    DocumentName: string;
    file: any;
    DocumentType: string;
    DocumentString: string;
    DatabaseID: number;
    OrganizationID: number;
}

export class DocumentsByFolderReqVm {
    DatabaseID: number;
    OrganizationID: number;
    FolderID: number;
   documentFolderID: any;
   officeID:number=0;
    OfficeIDList: any;
}